import {
  KeyboardArrowDown as ArrowDownIcon,
  Language as LanguageIcon,
  Menu as MenuIcon,
  Close as CloseIcon,
  Article as ArticleIcon,
  Dashboard as DashboardIcon,
  Widgets as WidgetsIcon,
  People as PeopleIcon,
  Payment as PaymentIcon,
  Settings as SettingsIcon,
  Search as SearchIcon,
  PlayArrow as PlayIcon,
  Palette
} from '@mui/icons-material';
import {
  AppBar,
  Box,
  Button,
  Container,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Menu,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
  Fade,
  Grid,
  Paper,
  alpha,
  TextField,
  InputAdornment,
  Chip,
  Stack,
  Collapse
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';

const Header = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentMenu, setCurrentMenu] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  // Scroll listener
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  // Search handler
  const handleSearch = (e) => {
    e.preventDefault();
    console.log('Searching for:', searchValue);
    // Burada arama logic'inizi ekleyin
    setSearchOpen(false);
    setSearchValue('');
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenuOpen = (event, menuName) => {
    setAnchorEl(event.currentTarget);
    setCurrentMenu(menuName);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setCurrentMenu(null);
  };

  const menuItems = [
    {
      title: 'Özellikler',
      items: [
        { 
          name: 'Haber İçerik Yönetimi', 
          path: '/content-management',
          icon: <ArticleIcon />,
          desc: 'Güçlü editör ve içerik yönetimi',
          color: '#3b82f6',
          badge: 'Popüler'
        },
        { 
          name: 'Sayfa Tasarımı', 
          path: '/page-design',
          icon: <DashboardIcon />,
          desc: 'Görerek tasarlanan sayfalar',
          color: '#8b5cf6',
          badge: 'Yeni'
        },
        { 
          name: 'Tema Yönetimi', 
          path: '/theme-design',
          icon: <Palette />,
          desc: 'Tema yönetimi',
          color: '#10b981'
        },
        { 
          name: 'Kullanıcı Yönetimi', 
          path: '/user-management',
          icon: <PeopleIcon />,
          desc: 'Rol tabanlı yetkilendirme',
          color: '#f59e0b'
        },
        { 
          name: 'Abonelik Sistemi', 
          path: '/subscription',
          icon: <PaymentIcon />,
          desc: 'Esnek gelir modelleri',
          color: '#ef4444',
          badge: 'Premium'
        },
        { 
          name: 'Teknik Altyapı', 
          path: '/technical-features',
          icon: <SettingsIcon />,
          desc: 'Güvenli ve hızlı teknoloji',
          color: '#06b6d4'
        }
      ]
    },
    { name: 'Çözümler', path: '/solutions' },
    { name: 'Fiyatlandırma', path: '/pricing', badge: 'Özel İndirim' },
    { name: 'İletişim', path: '/contact' }
  ];

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          bgcolor: scrolled ? 'var(--bg-overlay)' : 'transparent',
          backdropFilter: scrolled ? 'blur(20px)' : 'none',
          color: scrolled ? 'var(--text-primary)' : 'white',
          boxShadow: scrolled ? 'var(--shadow-light)' : 'none',
          borderBottom: scrolled ? '1px solid var(--border-primary)' : 'none',
          zIndex: 1300,
          transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
        }}
      >
        <Container maxWidth="xl">
          <Toolbar sx={{ px: 0, py: 1.5, justifyContent: 'space-between' }}>
            {/* Logo */}
            <Box 
              onClick={() => navigate('/')} 
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: { xs: 1, sm: 1.5 },
                cursor: 'pointer'
              }}
            >
              <Box
                sx={{
                  width: { xs: 40, sm: 50 },
                  height: { xs: 40, sm: 50 },
                  borderRadius: 2.5,
                  background: scrolled 
                    ? 'var(--gradient-primary)'
                    : 'rgba(255,255,255,0.15)',
                  backdropFilter: 'blur(10px)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: { xs: '1.4rem', sm: '1.8rem' }
                }}
              >
                📰
              </Box>
              <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 900,
                    fontSize: { xs: '1.4rem', sm: '1.8rem' },
                    color: scrolled ? 'var(--accent-primary)' : 'white',
                    lineHeight: 1
                  }}
                >
                  RONESİS
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: '0.65rem',
                    fontWeight: 600,
                    color: scrolled ? '#64748b' : 'rgba(255,255,255,0.8)'
                  }}
                >
                  Haber Platformu
                </Typography>
              </Box>
              {/* Mobile logo text */}
              <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 900,
                    fontSize: '1.2rem',
                    color: scrolled ? 'var(--accent-primary)' : 'white',
                    lineHeight: 1
                  }}
                >
                  RONESİS
                </Typography>
              </Box>
            </Box>

            {isMobile ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <IconButton
                  onClick={() => setSearchOpen(!searchOpen)}
                  sx={{ 
                    color: scrolled ? 'var(--accent-primary)' : 'white',
                    bgcolor: scrolled ? 'rgba(25, 118, 210, 0.1)' : 'rgba(255, 255, 255, 0.15)',
                    backdropFilter: 'blur(10px)',
                    border: scrolled ? '1px solid rgba(25, 118, 210, 0.2)' : '1px solid rgba(255, 255, 255, 0.2)',
                    borderRadius: 2,
                    p: 1,
                    '&:hover': {
                      bgcolor: scrolled ? 'rgba(25, 118, 210, 0.2)' : 'rgba(255, 255, 255, 0.25)',
                      transform: 'scale(1.05)'
                    },
                    transition: 'all 0.3s ease'
                  }}
                >
                  <SearchIcon sx={{ fontSize: '1.2rem' }} />
                </IconButton>
                <IconButton
                  onClick={handleDrawerToggle}
                  sx={{ 
                    color: scrolled ? 'var(--accent-primary)' : 'white',
                    bgcolor: scrolled ? 'rgba(25, 118, 210, 0.1)' : 'rgba(255, 255, 255, 0.15)',
                    backdropFilter: 'blur(10px)',
                    border: scrolled ? '1px solid rgba(25, 118, 210, 0.2)' : '1px solid rgba(255, 255, 255, 0.2)',
                    borderRadius: 2,
                    p: 1,
                    '&:hover': {
                      bgcolor: scrolled ? 'rgba(25, 118, 210, 0.2)' : 'rgba(255, 255, 255, 0.25)',
                      transform: 'scale(1.05)'
                    },
                    transition: 'all 0.3s ease'
                  }}
                >
                  <MenuIcon sx={{ fontSize: '1.2rem' }} />
                </IconButton>
              </Box>
            ) : (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {/* Menu Items */}
                {menuItems.map((item, index) => (
                  typeof item === 'object' && item.name ? (
                    <Button
                      key={index}
                      color="inherit"
                      onClick={() => navigate(item.path)}
                      sx={{
                        fontWeight: 600,
                        color: scrolled ? '#333' : 'white',
                        px: 2.5,
                        py: 1.2,
                        borderRadius: 2,
                        textTransform: 'none',
                        '&:hover': {
                          bgcolor: scrolled ? 'rgba(25, 118, 210, 0.1)' : 'rgba(255, 255, 255, 0.1)',
                          color: scrolled ? 'var(--accent-primary)' : 'white',
                          transform: 'translateY(-2px)'
                        },
                        transition: 'all 0.3s ease'
                      }}
                    >
                      {item.name}
                    </Button>
                  ) : (
                    <Button
                      key={index}
                      color="inherit"
                      endIcon={<ArrowDownIcon />}
                      onClick={(e) => handleMenuOpen(e, item.title)}
                      sx={{
                        fontWeight: 600,
                        color: scrolled ? '#333' : 'white',
                        px: 2.5,
                        py: 1.2,
                        borderRadius: 2,
                        textTransform: 'none'
                      }}
                    >
                      {item.title}
                    </Button>
                  )
                ))}

                <Divider orientation="vertical" flexItem sx={{ mx: 1, height: 30, alignSelf: 'center' }} />

                {/* Search */}
                <IconButton
                  onClick={() => setSearchOpen(!searchOpen)}
                  sx={{
                    color: scrolled ? '#666' : 'rgba(255, 255, 255, 0.9)',
                    border: scrolled ? '1px solid #e0e0e0' : '1px solid rgba(255, 255, 255, 0.2)'
                  }}
                >
                  <SearchIcon />
                </IconButton>

                {/* Dark Mode */}
                {/* <ThemeToggle 
                  variant="icon"
                  size="small"
                  sx={{
                    color: scrolled ? '#666' : 'rgba(255, 255, 255, 0.9)',
                    border: scrolled ? '1px solid #e0e0e0' : '1px solid rgba(255, 255, 255, 0.2)'
                  }}
                /> */}

                {/* Language */}
                <IconButton
                  sx={{
                    color: scrolled ? '#666' : 'rgba(255, 255, 255, 0.9)',
                    border: scrolled ? '1px solid #e0e0e0' : '1px solid rgba(255, 255, 255, 0.2)'
                  }}
                >
                  <LanguageIcon />
                </IconButton>

                <Divider orientation="vertical" flexItem sx={{ mx: 1, height: 30, alignSelf: 'center' }} />

                {/* CTA Buttons */}
                <Button
                  variant="contained"
                  startIcon={<PlayIcon />}
                  sx={{
                    background: scrolled 
                      ? 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)'
                      : 'rgba(255, 255, 255, 0.95)',
                    color: scrolled ? 'white' : '#1976d2',
                    fontWeight: 700,
                    px: 3,
                    py: 1.2,
                    borderRadius: 2.5,
                    textTransform: 'none'
                  }}
                >
                  Demo İzle
                </Button>
              </Box>
            )}
          </Toolbar>
        </Container>

        {/* FIXED: Search Bar - Daha modern ve çalışan versiyon */}
        <Collapse in={searchOpen}>
          <Box
            sx={{
              bgcolor: 'white',
              borderTop: '1px solid rgba(0,0,0,0.05)',
              py: 3,
              boxShadow: '0 10px 40px rgba(0,0,0,0.1)'
            }}
          >
            <Container maxWidth="md">
              <Box component="form" onSubmit={handleSearch}>
                <TextField
                  fullWidth
                  placeholder="Ne aramak istersiniz?"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  autoFocus
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 3,
                      bgcolor: '#f8f9fa',
                      fontSize: '1.1rem',
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                        borderWidth: 2
                      },
                      '&:hover fieldset': {
                        borderColor: '#1976d2'
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#1976d2',
                        borderWidth: 2
                      }
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ fontSize: '1.5rem', color: '#1976d2' }} />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <Stack direction="row" spacing={1}>
                          <Button
                            type="submit"
                            variant="contained"
                            size="small"
                            sx={{
                              background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
                              textTransform: 'none',
                              fontWeight: 600
                            }}
                          >
                            Ara
                          </Button>
                          <IconButton 
                            size="small"
                            onClick={() => {
                              setSearchOpen(false);
                              setSearchValue('');
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Stack>
                      </InputAdornment>
                    )
                  }}
                />
              </Box>
              
              {/* Popüler Aramalar */}
              <Box sx={{ mt: 2 }}>
                <Typography variant="caption" sx={{ color: '#64748b', mr: 1, fontWeight: 600 }}>
                  Popüler Aramalar:
                </Typography>
                <Stack direction="row" spacing={1} flexWrap="wrap" gap={1} mt={1}>
                  {['Haber Yazılımı', 'Widget Galerisi', 'Fiyatlandırma', 'Demo', 'İletişim'].map((tag) => (
                    <Chip
                      key={tag}
                      label={tag}
                      size="small"
                      onClick={() => {
                        setSearchValue(tag);
                        // Arama yap
                        console.log('Searching for:', tag);
                      }}
                      sx={{
                        cursor: 'pointer',
                        bgcolor: '#f1f5f9',
                        '&:hover': {
                          bgcolor: 'rgba(25, 118, 210, 0.1)',
                          color: '#1976d2'
                        }
                      }}
                    />
                  ))}
                </Stack>
              </Box>
            </Container>
          </Box>
        </Collapse>
      </AppBar>

      {/* FIXED: Mega Menu - Taşma sorunu düzeltildi */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        TransitionComponent={Fade}
        disableScrollLock
        sx={{
          '& .MuiPaper-root': {
            mt: 2,
            maxWidth: 800,
            boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
            borderRadius: 3,
            overflow: 'hidden' // FIXED: Taşmayı önler
          },
          '& .MuiList-root': {
            p: 0
          }
        }}
      >
        <Box sx={{ p: 3, maxHeight: '80vh', overflowY: 'auto' }}>
          {/* Header */}
          <Box sx={{ mb: 3 }}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 700, 
                color: '#1e293b',
                mb: 0.5
              }}
            >
              {currentMenu}
            </Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                color: '#64748b'
              }}
            >
              Haber siteniz için ihtiyacınız olan tüm özellikler
            </Typography>
          </Box>

          {/* FIXED: Grid with proper spacing */}
          <Grid container spacing={2}>
            {currentMenu && menuItems.find(item => typeof item === 'object' && item.title === currentMenu)?.items.map((subItem, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Paper
                  elevation={0}
                  onClick={() => {
                    navigate(subItem.path);
                    handleMenuClose();
                  }}
                  sx={{
                    p: 2,
                    cursor: 'pointer',
                    border: '1px solid #e2e8f0',
                    borderRadius: 2,
                    background: '#ffffff',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: `0 8px 20px ${alpha(subItem.color, 0.15)}`,
                      borderColor: subItem.color
                    }
                  }}
                >
                  {/* Badge */}
                  {subItem.badge && (
                    <Chip
                      label={subItem.badge}
                      size="small"
                      sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        height: 20,
                        fontSize: '0.7rem',
                        fontWeight: 700,
                        bgcolor: subItem.badge === 'Yeni' ? '#10b981' : '#f59e0b',
                        color: 'white'
                      }}
                    />
                  )}

                  <Stack direction="row" spacing={2} alignItems="flex-start">
                    {/* Icon */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 40,
                        height: 40,
                        borderRadius: 2,
                        background: `${alpha(subItem.color, 0.1)}`,
                        color: subItem.color,
                        flexShrink: 0
                      }}
                    >
                      {subItem.icon}
                    </Box>

                    {/* Content */}
                    <Box flex={1}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#1e293b',
                          mb: 0.5
                        }}
                      >
                        {subItem.name}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color: '#64748b',
                          display: 'block'
                        }}
                      >
                        {subItem.desc}
                      </Typography>
                    </Box>
                  </Stack>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Menu>

      {/* Mobile Drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        sx={{
          '& .MuiDrawer-paper': {
            width: 300,
            bgcolor: '#fafafa',
            borderRadius: '0 20px 20px 0',
            boxShadow: '0 8px 40px rgba(0,0,0,0.15)'
          }
        }}
      >
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          {/* Mobile Header */}
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between',
            p: 2,
            borderBottom: '1px solid #e0e0e0'
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: 2,
                  background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.5rem'
                }}
              >
                📰
              </Box>
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 800, color: '#1976d2', fontSize: '1.3rem', lineHeight: 1 }}>
                  RONESİS
                </Typography>
                <Typography variant="caption" sx={{ fontSize: '0.6rem', fontWeight: 600, color: '#64748b' }}>
                  Haber Platformu
                </Typography>
              </Box>
            </Box>
            <IconButton onClick={handleDrawerToggle} sx={{ color: '#666' }}>
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Mobile Menu Items */}
          <Box sx={{ flex: 1, overflow: 'auto', p: 2 }}>
            <List sx={{ p: 0 }}>
              {menuItems.map((item, index) => (
                <ListItem 
                  key={index} 
                  disablePadding
                  sx={{
                    mb: 1,
                    borderRadius: 2,
                    '&:hover': {
                      bgcolor: 'rgba(25, 118, 210, 0.1)'
                    }
                  }}
                >
                  {typeof item === 'object' && item.title ? (
                    <Box sx={{ width: '100%' }}>
                      <ListItemText
                        primary={item.title}
                        sx={{ 
                          textAlign: 'left', 
                          py: 1.5,
                          px: 2,
                          '& .MuiTypography-root': {
                            fontWeight: 600,
                            color: '#333',
                            fontSize: '1rem'
                          }
                        }}
                      />
                      {/* Submenu items */}
                      <Box sx={{ pl: 2, pb: 1 }}>
                        {item.items?.map((subItem, subIndex) => (
                          <ListItem 
                            key={subIndex}
                            disablePadding
                            onClick={() => {
                              navigate(subItem.path);
                              handleDrawerToggle();
                            }}
                            sx={{
                              mb: 0.5,
                              borderRadius: 1.5,
                              cursor: 'pointer',
                              '&:hover': {
                                bgcolor: 'rgba(25, 118, 210, 0.05)'
                              }
                            }}
                          >
                            <ListItemText
                              primary={subItem.name}
                              sx={{ 
                                py: 1,
                                px: 2,
                                '& .MuiTypography-root': {
                                  fontWeight: 500,
                                  color: '#555',
                                  fontSize: '0.9rem'
                                }
                              }}
                            />
                          </ListItem>
                        ))}
                      </Box>
                    </Box>
                  ) : (
                    <ListItemText
                      primary={item.name}
                      onClick={() => {
                        navigate(item.path);
                        handleDrawerToggle();
                      }}
                      sx={{ 
                        textAlign: 'left', 
                        py: 1.5,
                        px: 2,
                        cursor: 'pointer',
                        '& .MuiTypography-root': {
                          fontWeight: 600,
                          color: '#333',
                          fontSize: '1rem'
                        }
                      }}
                    />
                  )}
                </ListItem>
              ))}
            </List>
            
            <Divider sx={{ my: 3 }} />
            
            {/* Mobile CTA Buttons */}
            <Box sx={{ px: 2, pb: 2 }}>
              <Button
                variant="contained"
                fullWidth
                startIcon={<PlayIcon />}
                sx={{
                  mb: 2,
                  background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
                  color: 'white',
                  fontWeight: 700,
                  py: 1.5,
                  borderRadius: 3,
                  textTransform: 'none',
                  fontSize: '1rem',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 8px 25px rgba(25, 118, 210, 0.3)'
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                Demo İzle
              </Button>
              
              <Button
                variant="outlined"
                fullWidth
                sx={{
                  borderColor: '#1976d2',
                  color: '#1976d2',
                  fontWeight: 600,
                  py: 1.5,
                  borderRadius: 3,
                  textTransform: 'none',
                  fontSize: '1rem',
                  '&:hover': {
                    bgcolor: 'rgba(25, 118, 210, 0.1)',
                    borderColor: '#1976d2'
                  }
                }}
              >
                Müşteri Paneli
              </Button>
            </Box>
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default Header;